import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PlusIcon: FC<PropsT> = ({ fill = '#909090' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M6.49875 7.50125L0.439686 7.50126C0.195568 7.50126 -0.00400708 7.30307 6.11124e-05 7.05899C0.000972577 7.0043 0.00203657 6.97308 0.00305113 6.95406C0.016284 6.70585 0.202609 6.50109 0.451163 6.50109L6.49875 6.50109L6.49875 0.442015C6.49875 0.197897 6.69665 2.4157e-07 6.94076 7.78758e-08L7.0569 0C7.30102 -1.63694e-07 7.49892 0.197897 7.49892 0.442016L7.49891 6.50109L13.558 6.50108C13.8021 6.50108 14 6.69898 14 6.9431V7.05924C14 7.30335 13.8021 7.50125 13.558 7.50125L7.49891 7.50125L7.49891 13.5603C7.49891 13.8044 7.30073 14.004 7.05665 13.9999C7.00196 13.999 6.97074 13.998 6.95171 13.997C6.70351 13.9837 6.49875 13.7974 6.49875 13.5488L6.49875 7.50125Z" fill={fill}/>
</svg>
);

export default PlusIcon;
import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const PlusIcon: FC<PropsT> = ({ fill = '#909090' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M6.49875 7.50125L0.439686 7.50126C0.195568 7.50126 -0.00400708 7.30307 6.11124e-05 7.05899C0.000972577 7.0043 0.00203657 6.97308 0.00305113 6.95406C0.016284 6.70585 0.202609 6.50109 0.451163 6.50109L6.49875 6.50109L6.49875 0.442015C6.49875 0.197897 6.69665 2.4157e-07 6.94076 7.78758e-08L7.0569 0C7.30102 -1.63694e-07 7.49892 0.197897 7.49892 0.442016L7.49891 6.50109L13.558 6.50108C13.8021 6.50108 14 6.69898 14 6.9431V7.05924C14 7.30335 13.8021 7.50125 13.558 7.50125L7.49891 7.50125L7.49891 13.5603C7.49891 13.8044 7.30073 14.004 7.05665 13.9999C7.00196 13.999 6.97074 13.998 6.95171 13.997C6.70351 13.9837 6.49875 13.7974 6.49875 13.5488L6.49875 7.50125Z" fill={fill}/>
</svg>
);

export default PlusIcon;
